import { render, staticRenderFns } from "./ProductSignAdd.vue?vue&type=template&id=a34c6838&scoped=true&"
import script from "./ProductSignAdd.vue?vue&type=script&lang=js&"
export * from "./ProductSignAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34c6838",
  null
  
)

export default component.exports